import { configureStore } from '@reduxjs/toolkit';
import { registrationReducer } from './registration/registration.reducer';
import { authReducer } from './auth/auth.reducer';
import { AuthState } from './auth/auth.interface';
import { RegistrationState } from './registration/registration.interface';

export interface State {
  registration: RegistrationState,
  auth: AuthState
}

export default configureStore({
  reducer: {
    registration: registrationReducer,
    auth: authReducer
  }
});
